import moment from 'moment';

export function updateDateWithTime(dateHour, timeString) {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    const date = dateHour.split('T')[0];
    let updatedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    if (seconds) {
        updatedTime += `:${seconds.toString().padStart(2, '0')}`;
    } else {
        updatedTime += `:00`;
    }
    const updatedDate = `${date}T${updatedTime}`;

    return updatedDate;
}
export function applySpecificTime(date, timeString) {
    const [hour, minute] = timeString.split(':').map(Number);
    return date.clone().set({ hour, minute, second: 0, millisecond: 0 });
}
export function subtractMinutes(currentDate : moment.Moment, minute : number, minTime : moment.Moment) {
    const newDate = currentDate.subtract(minute, 'minutes');

    if (newDate.isBefore(minTime)) {
        return minTime;
    }
    return newDate;
}
export function roundToNearestTenSeconds(time: moment.Moment): moment.Moment {
    const seconds = time.seconds();
    const roundedSeconds = Math.floor(seconds / 10) * 10;
    return time.seconds(roundedSeconds);
}